'use strict';

require('react');
var SymbolsCounter_style = require('./SymbolsCounter.style-64b0606b.js');
var react = require('@emotion/react');

var InputStatusIcon = function InputStatusIcon(_ref) {
  var status = _ref.status,
    ariaHidden = _ref['aria-hidden'];
  switch (status) {
    case 'hasError':
      return react.jsx(SymbolsCounter_style.ErrorIcon, {
        "aria-hidden": ariaHidden,
        role: "img"
      });
    case 'isFilled':
      return react.jsx(SymbolsCounter_style.FilledIcon, {
        "aria-hidden": ariaHidden,
        role: "img"
      });
    default:
      return null;
  }
};

exports.InputStatusIcon = InputStatusIcon;
//# sourceMappingURL=InputStatusIcon-f8340fe4.js.map
